import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PermissionHandler } from '@clearing-hub/angular-common';
import { UserService } from '../../service/user.service';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../service/authentication.service';

@Component({
  selector: 'fxch-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent extends PermissionHandler {

  @Input()
  isExpanded = false;
  @Output()
  toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private readonly userService: UserService,
              private readonly authenticationService: AuthenticationService,
              private readonly router: Router) {
    super(authenticationService.getUserPermissions())
  }

  handleSidebarToggle() {
    this.toggleSidebar.emit(!this.isExpanded);
  }

  logout() {
    localStorage.removeItem('currentAdmin');
    this.userService.logout().subscribe({
      next: () => {
        this.router.navigateByUrl('login');
      },
      error: () => {
        this.router.navigateByUrl('login');
      }
    });
  }
}
